import { MenuLinkTypeEnum } from 'common/components/entities/Menu/enums/MenuLinkTypeEnum'
import { MobileMenuTypesEnum } from 'common/components/entities/Menu/enums/MobileMenuTypesEnum'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'

export const mobileMenuTypesLocoKeys: Record<MobileMenuTypesEnum, string> = {
  [MobileMenuTypesEnum.dropDown]: 'entity_settings.menu.mobile_type.drop_down',
  [MobileMenuTypesEnum.side]: 'entity_settings.menu.mobile_type.side',
}

export const menuLinkTypeLocoKeys: Record<MenuLinkTypeEnum, string> = {
  [MenuLinkTypeEnum.link_type_custom_url]:
    'entity_settings.menu.item.link_type.custom_url',
  [MenuLinkTypeEnum.link_type_blog_page]:
    'entity_settings.menu.item.link_type.blog_page',
  [MenuLinkTypeEnum.link_type_website_page]:
    'entity_settings.menu.item.link_type.website_page',
}

export const allowedBlogLinksPageTypes = [
  PageTypeEnum.BlogLayout,
  PageTypeEnum.BlogPostLayout,
  PageTypeEnum.BlogHome,
  PageTypeEnum.BlogStatic,
  PageTypeEnum.BlogPostListing,
  PageTypeEnum.BlogSearch,
]
